"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _redbook = _interopRequireDefault(require("@/api/activity/redbook.js"));
var _taskConfig = require("@/api/taskConfig/taskConfig.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
  name: 'trendSetterList',
  components: {},
  props: {
    refresh: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler: function handler(newId, oldId) {
        // 避免初始化时的不必要调用
        // if (newId === oldId && oldId !== undefined) return;

        // console.log('newId', newId)
        // if (newId) {
        //     this.fetchList()
        // }
      }
    }
  },
  emits: ['addAct', 'handleEdit', 'detailUserLog'],
  data: function data() {
    return {
      title: '添加种草官',
      resPath: process.env.VUE_APP_IMAGE_PATH,
      loading: false,
      times: [],
      searchForm: {
        keywords: '',
        status: '',
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      addDialogVisible: false,
      addForm: {
        name: '',
        phone: '',
        status: 1
      },
      addRules: {
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1\d{10}$/,
          message: '请输入有效的手机号',
          trigger: 'blur'
        }]
      },
      // 奖励记录弹窗相关
      rewardDialogVisible: false,
      rewardList: [],
      rewardLoading: false,
      rewardSearch: {
        page: 1,
        limit: 10,
        total: 0
      },
      currentOfficerId: null
    };
  }
}, "watch", {
  refresh: {
    immediate: true,
    handler: function handler(newId, oldId) {
      if (newId) {
        this.fetchList();
      }
    }
  }
}), "computed", {
  maxHeight: function maxHeight() {
    return "".concat(window.innerHeight - 497, "px");
  }
}), "methods", {
  detailUserLog: function detailUserLog(row) {
    this.$emit('detailUserLog', row.id);
  },
  RewardUserLog: function RewardUserLog(row) {
    this.$emit('RewardUserLog', row.id);
  },
  openRewardDialog: function openRewardDialog(row) {
    this.currentOfficerId = row.id;
    this.rewardSearch.page = 1;
    this.rewardDialogVisible = true;
    this.fetchRewardList();
  },
  fetchRewardList: function fetchRewardList() {
    var _this = this;
    if (!this.currentOfficerId) return;
    this.rewardLoading = true;
    var params = {
      page: this.rewardSearch.page,
      limit: this.rewardSearch.limit,
      officerId: this.currentOfficerId
    };
    _redbook.default.officerRewardLog(params).then(function (res) {
      var records = res.records || [];
      // 格式化时间字段（如果存在）
      records.forEach(function (item) {
        if (item.createDate) {
          try {
            var date = new Date(item.createDate);
            var y = date.getFullYear();
            var m = _this.pad(date.getMonth() + 1);
            var d = _this.pad(date.getDate());
            var hh = _this.pad(date.getHours());
            var mm = _this.pad(date.getMinutes());
            var ss = _this.pad(date.getSeconds());
            item.createTime = "".concat(y, "-").concat(m, "-").concat(d, " ").concat(hh, ":").concat(mm, ":").concat(ss);
          } catch (e) {}
        }
      });
      _this.rewardList = records;
      _this.rewardSearch.total = res.total || 0;
    }).finally(function () {
      _this.rewardLoading = false;
    });
  },
  handleRewardSizeChange: function handleRewardSizeChange(newSize) {
    this.rewardSearch.limit = newSize;
    this.rewardSearch.page = 1;
    this.fetchRewardList();
  },
  handleRewardPageChange: function handleRewardPageChange(newPage) {
    this.rewardSearch.page = newPage;
    this.fetchRewardList();
  },
  addOffcer: function addOffcer(row) {
    if (row.id) {
      this.title = '编辑种草官';
      this.addForm.name = row.name;
      this.addForm.phone = row.phone;
      this.addForm.id = row.id;
      this.addForm.status = row.status;
    }
    this.addDialogVisible = true;
  },
  submitAdd: function submitAdd() {
    var _this2 = this;
    this.$refs.addFormRef.validate(function (valid) {
      if (valid) {
        _redbook.default.addOfficer(_this2.addForm).then(function (res) {
          if (res.code === 200) {
            _this2.loading = false; // 停止加载
            _this2.$message.success('操作成功');
            _this2.addDialogVisible = false;
            _this2.fetchList();
          } else {
            _this2.loading = false; // 停止加载
            _this2.$message.error(res.message);
          }
        });
      }
    });
  },
  resetAddForm: function resetAddForm() {
    if (this.$refs.addFormRef) {
      this.$refs.addFormRef.resetFields();
    }
    this.addForm.name = '';
    this.addForm.phone = '';
  },
  handleCustomUpload: function handleCustomUpload(option) {
    var _this3 = this;
    var file = option && option.file ? option.file : option;
    var formData = new FormData();
    formData.append('file', file);
    _redbook.default.importOfficer(formData).then(function (res) {
      _this3.$message.success('上传成功');
      _this3.fetchList();
    }).catch(function () {
      _this3.$message.error('上传失败');
    });
  },
  changeTime: function changeTime(e) {
    console.log(e);
    if (!e || e.length === 0) {
      // 清除筛选条件
      this.searchForm.startTime = '';
      this.searchForm.endTime = '';
      this.fetchList(); // 重新加载数据
    } else {
      this.searchForm.startTime = e[0];
      this.searchForm.endTime = e[1];
      console.log((0, _typeof2.default)(e[0]), e[0]);
    }
  },
  pad: function pad(n) {
    return n.toString().padStart(2, '0');
  },
  fetchList: function fetchList() {
    var _this4 = this;
    // return
    this.loading = true;
    _redbook.default.getofficer(this.searchForm).then(function (res) {
      res.records.forEach(function (item) {
        var date = new Date(item.updateTime);
        var year = date.getFullYear();
        var month = _this4.pad(date.getMonth() + 1);
        var day = _this4.pad(date.getDate());
        var hours = _this4.pad(date.getHours());
        var mins = _this4.pad(date.getMinutes());
        var secs = _this4.pad(date.getSeconds());
        item.updateTime = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(mins, ":").concat(secs);
      });
      _this4.tableData = res.records || [];
      _this4.searchForm.total = res.total || 0;
    }).finally(function () {
      _this4.loading = false;
    });
  },
  download: function download() {
    var _this5 = this;
    this.downloadLoading = true;
    var params = {
      keywords: this.searchForm.keywords
    };
    _redbook.default.exportOffircer(params).then(function (response) {
      var blob = new Blob([response], {
        type: 'application/vnd.ms-excel'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = '种草官列表.xlsx';
      link.click();
      window.URL.revokeObjectURL(link.href);
    }).finally(function () {
      _this5.downloadLoading = false;
    });
  },
  // 每页条数变化
  handleSizeChange: function handleSizeChange(newSize) {
    this.searchForm.limit = newSize;
    this.searchForm.page = 1;
    this.fetchList();
  },
  // 页码变化
  handlePageChange: function handlePageChange(newPage) {
    this.searchForm.page = newPage;
    this.fetchList();
  }
}), "mounted", function mounted() {
  this.fetchList();
});